// extracted by mini-css-extract-plugin
export default {"dateContainer":"Balance_dateContainer__0u+zQ","date":"Balance_date__uLhxv","scrollButton":"Balance_scrollButton__FY3Nd"};